const translateText = (lang: string, translatedText: ITranslatedText) => {
    if (!translatedText?.tr) return '<ERROR>'
    const translation = translatedText.tr.find(t => t.lang === lang)
    return translation ? translation.text : translatedText.tr[0]?.text // Default to the first translation
}

export default translateText
